import React from 'react';
import {Button, Glyphicon, Navbar, Table} from 'react-bootstrap';

import EventSourcesSelectForm from "../event-sources-select-form";
import AvailableDictionaryItemsSelect from "../../dialogs/available-dictionary-items-select";
import DeleteConflictOrphansDialog from "../../dialogs/delete-conflict-orphans";


const MODAL_MODE = {
	ADD: 0,
	EDIT: 1
};

class EventSourcesTab
	extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			eventSources: this.props.eventSources ? this.props.eventSources : [],
			selectedEventSources: props.eventSources ? props.eventSources : [],
			selected: null,
			showModal: false,
			modalMode: MODAL_MODE.ADD
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.eventSources !== this.props.eventSources) {
			this.setState({
				              eventSources: this.props.eventSources ? this.props.eventSources : [],
			              })
		}
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			              error: true
		              })
	}

	handleOnItemClick = (item) => {
		this.setState({selected: item.id});
	};

	addButtonHandler = () => {
		this.setState({
			              modalMode: MODAL_MODE.ADD,
			              showModal: true
		              });
	};

	handleOnSave = (eventSources) => {
		if (this.state.modalMode === MODAL_MODE.ADD) {
			this.props.onAdd(eventSources, (eventSources) => {
				this.setState({
					              eventSources: eventSources,
					              modalMode: null,
					              showModal: false
				              });
			});
		}
	};

	render() {

		if (this.state.error) {
			return <div className="tab-content">Error occurred...</div>
		}

		return (
			<div className="tab-content">
				<Navbar fluid={true} bsClass="c-navbar navbar-default">
					<div className="tab-buttons-group">
						{
							this.props.hasSelectButton &&
							<Button bsClass="btn icon action-button" onClick={this.addButtonHandler}>
								<Glyphicon glyph="plus" className="c-glyph-icon"/>
								<div className="label-wrapper">
									<label>Select</label>
								</div>
							</Button>
						}
					</div>
				</Navbar>
				<div className="table-wrapper">
					<Table>
						<thead>
						<tr>
							<th>Name</th>
							<th>Description</th>
						</tr>
						</thead>
						<tbody>
						{
							this.state.eventSources
							    .map(item => {
								    return (
									    <tr key={item.id}
									        className={this.state.selectedId && this.state.selectedId === item.id ? 'selected' : ''}>
										    <td>{item.title}</td>
										    <td>{item.description}</td>
									    </tr>
								    );
							    })
						}
						</tbody>
					</Table>
				</div>
				{
					<AvailableDictionaryItemsSelect show={this.state.showModal}
					                                onHide={() => this.setState({showModal: false})}
					                                title={"Event Sources"}
					                                items={this.props.availableEventSources}
					                                selectedItems={this.state.eventSources}
					                                onSave={this.handleOnSave}
					                                onSelectionChange={(items) => {
						                                this.setState({
							                                              selectedEventSources: items
						                                              })
					                                }}
					/>
				}
				{
					this.props.orphans && this.props.orphans.length !== 0 &&
					<DeleteConflictOrphansDialog show={this.props.orphans && this.props.orphans.length !== 0}
					                             title={"Orphans"}
					                             items={this.props.orphans}
					                             selectedItem={this.props.selectedOrphan}
					                             itemInfoProvider={this.props.itemInfoProvider}
					                             onItemClicked={
						                             (item) => {
							                             this.props.selectOrphan(item);
						                             }
					                             }
					                             onHide={
						                             () => {
							                             this.props.clearOrphans();
						                             }
					                             }
					                             onProceed={
						                             (e) => {
							                             this.handleOnSave(this.state.selectedEventSources)
						                             }
					                             }/>
				}
			</div>
		);
	}
}

export default EventSourcesTab;